// extracted by mini-css-extract-plugin
module.exports = {"auctionDate":"AuctionDate_auctionDate__3RiZT"};